import React, { useState, useRef } from 'react'
import { connect } from 'dva'
import PropTypes from 'prop-types'
import actions from '../actions'
import Button from '../../../../Button'
import ContextMenu from '../../../ContextMenu'
import MoreHorizontal from '../../../../../assets/svg/Feather/MoreHorizontal'
import styles from './FeatureContextMenu.module.scss'
import useOnClickOutside from '../../../../../lib/hooks/useOnClickOutside'

function FeatureContextMenu(props) {
  const [showContextMenu, setShowContextMenu] = useState(false)
  const contextMenuRef = useRef(null)
  useOnClickOutside(contextMenuRef, () => {
		setShowContextMenu(false)
	})
  const displayContextMenu = () => {
    setShowContextMenu(!showContextMenu)
  }

  return (
    <div className={styles.contextButtonContainer} ref={contextMenuRef}>
      <Button
        onClick={displayContextMenu}
        size={Button.SIZE.small} 
        theme={Button.THEME.solidSecondary}
      >
        <MoreHorizontal width={16} color='#fff' />
      </Button>
      {showContextMenu ? (
        <ContextMenu
          className={styles.contextMenu}
          menuItems={[
            {
              title: 'Import',
              onClick: () => props.importContent(),
            },
            {
              title: 'Export All',
              onClick: () => props.exportAllContent(),
            }
          ]} />
      ) : (
        null
      )}
    </div>
  )
}

FeatureContextMenu.propTypes = {
  // actions
  exportAllContent: PropTypes.func,
  importContent: PropTypes.func,
}

export default connect(() => ({}), actions)(FeatureContextMenu)
